import React, { useState } from "react";
import Button from "../../ui/Button/Button";
import styles from "./ModalWaIntegrationForm.module.scss";
import { ClipLoader } from "react-spinners";
import WhatsAppIcon from "../../assets/icons/WhatsAppIcon";
import Title from "../../ui/Title/Title";
import { useDispatch, useSelector } from "react-redux";
import InputWithMask from "../../ui/InputWithMask/InputWithMask";
import { RefreshIcon } from "../../assets/icons/RefreshIcon";
import { QRCodeSVG } from "qrcode.react";
import { useModal } from "../../context/ModalContext";
import { Modal } from "../../ui/Modal/Modal";
import { getQrCodeWa } from "../../utils/api/actions/integrations/whatsapp";

const ModalWaIntegrationForm = ({ visible, handlerClose }) => {
  const dispatch = useDispatch();

  const { closeModal } = useModal();

  const loadingWa = useSelector((state) => state?.integration?.loadingWa);
  const { outdatedСode } = useSelector((state) => state?.integration);

  const [isPhoneInput, setIsPhoneInput] = useState(true);
  const [phone, setPhone] = useState("");
  const [errors, setErrors] = useState({ phone: "" });
  const [textQR, setTextQR] = useState("");

  const sanitizeValue = (value) => value.replace(/[-_\s]/g, "");

  const handlePhoneChange = (e) => {
    const newPhone = e.target.value;
    setPhone(newPhone);
    setErrors({
      ...errors,
      phone: sanitizeValue(newPhone).length === 11 ? "" : "Некорректный номер",
    });
  };

  const validateInputs = () => {
    const newErrors = { phone: "", code: "", password: "" };

    if (sanitizeValue(phone).length < 11) {
      newErrors.phone = "Некорректный номер";
    }
    setErrors(newErrors);
    return !Object.values(newErrors).some((error) => error !== "");
  };

  const handleSendData = () => {
    let dataWa = {
      userId: localStorage.getItem("@storage_User_Id"),
      clientIdentifier: sanitizeValue(phone),
    };
    dispatch(getQrCodeWa(dataWa, setTextQR, closeModal));
    setIsPhoneInput(false);
  };

  const handleKeyDown = (e) => {
    if (!errors.phone && e.key === "Enter") {
      handleSendData();
    }
  };

  return (
    <Modal visible={visible} handleClose={handlerClose}>
      <div className={styles.layout}>
        <div className={styles.header}>
          <Title title="Новая интеграция" className={styles.title} />
          <WhatsAppIcon size={25} fill={"#43d854"} />
        </div>

        {isPhoneInput ? (
          <div className={styles.content}>
            <div className={styles.inputGroup}>
              <div className={styles.inputContainer}>
                <InputWithMask
                  className={styles.child}
                  label="Номер телефона"
                  labelStyle={styles.labelInput}
                  backgroundStyle={styles.labelBackground}
                  inputStyle={`${styles.input} ${
                    errors.phone ? styles.error : ""
                  }`}
                  value={phone}
                  placeholder={"7 999 - 999 - 99 - 99"}
                  onChange={handlePhoneChange}
                  onKeyPress={handleKeyDown}
                />
              </div>
              {errors.phone && (
                <p className={styles.errorText}>{errors.phone}</p>
              )}
            </div>
            <Button
              onClick={() => (validateInputs() ? handleSendData() : undefined)}
              className={styles.nextButton}
              titleClassName={styles.nextButtonTitle}
              leftIcon={
                loadingWa ? <ClipLoader size={20} color="white" /> : null
              }
              title={"Отправить"}
            />
          </div>
        ) : (
          <div className={styles.content}>
            <div className={styles.body}>
              <div style={{ fontWeight: "bolder" }} className={styles.title}>
                {outdatedСode
                  ? "QR-код устарел"
                  : "Отсканируйте QR-код в приложении"}
                {outdatedСode && (
                  <div onClick={handleSendData} className={styles.refreshIcon}>
                    <RefreshIcon size={20} fill={"#151515"} />
                  </div>
                )}
              </div>
              <div className={styles.title}>
                Не закрывайте окно, пока синхронизация в WhatsApp не закончится
              </div>
              {loadingWa ? (
                <ClipLoader />
              ) : (
                <div className={styles.imageContainer}>
                  {/* <img className={styles.image} src={image} alt="QR Code" /> */}
                  <QRCodeSVG
                    value={textQR}
                    size={256}
                    bgColor={"#ffffff"}
                    fgColor={"#000000"}
                    level={"H"}
                  />
                </div>
              )}
              <div className={styles.title}>
                Не получилось подключить WhatsApp? - обновите QR-код
                <span className={styles.wordLink} onClick={handleSendData}>
                  здесь
                </span>{" "}
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ModalWaIntegrationForm;
